import { AgFinancingMatricula, AgFinancingMatriculaDetail } from '@indigo-ag/schema';

import { CollateralUtil } from 'shared';

interface Totals {
  cultivableArea: number;
  percentageArea: number;
}

export const getTotals = (acc: Totals, current: AgFinancingMatriculaDetail): Totals => {
  return {
    cultivableArea: acc.cultivableArea + (current.cultivableArea || 0),
    percentageArea: acc.percentageArea + (current.cultivableArea || 0) * 0.6
  };
};

export const getDetail = (legal: boolean, matricula: AgFinancingMatricula) => {
  return matricula.details?.find(d => !!d.id);
};

export const getFreeArea = (
  matriculas: AgFinancingMatricula[] = [],
  includedInFormalization?: boolean,
  excludeFilter?: boolean
): Totals => {
  return matriculas
    .filter(m => excludeFilter || (includedInFormalization ? m.includedInFormalization : m.includedInAnalysis))
    .reduce((acc, current) => {
      const detail = current.details?.find(d => !!d.id && CollateralUtil.hasRegistrationNumber(d));
      if (!!detail) {
        acc = [...acc, detail];
      }
      return acc;
    }, [] as AgFinancingMatriculaDetail[])
    .reduce(getTotals, { cultivableArea: 0, percentageArea: 0 });
};
